module.exports = __webpack_public_path__ + "img/Tele-Background-M.24fc64f1.png";